$(function() {
  console.log('layout.js');
  // タブレットレイアウトをPCと統一
  var metaDiscre = document.head.children;
  var metaLength = metaDiscre.length;
  if(window.outerWidth > 700 && window.outerWidth < 1200){
    for(var i = 0;i < metaLength;i++){
       var proper = metaDiscre[i].getAttribute('name');
        if(proper === 'viewport'){
          var dis = metaDiscre[i];
          dis.setAttribute('content','width=1200');
        }
    }
  }

  // トップページ ローディングアニメーション
  function loadingAnimation() {

    function init() {
      setTimeout(function() {
        $('#loadingInner').addClass('loaded');
        setTimeout(function() {
          $('#indexLoading').addClass('loaded');
        }, 2500);
      }, 1000);
    }

    init();

  }

  if (document.getElementById('indexLoading')) {
    loadingAnimation();
  }


  // ハンバーガーメニューの開閉
  function humMenuControll(target){
    var header = $('#humButton')
    var humButton = $('#humButton button');
    var closeButton = $('#humClose');
    var humState = 0;

    function hummenuMove(){
      if(humState == 0){
        target.addClass('open');
        header.addClass('hum_open');
        humState = 1;
      }else{
        target.removeClass('open');
        header.removeClass('hum_open');
        humState = 0;
      }
    }

    function init(){
      humButton.on({
        'click': function() {
          hummenuMove();
        }
      });
      closeButton.on({
        'click': function() {
          hummenuMove();
        }
      });
    }

    init();
  }

  humMenuControll($('#hummenu'));

  function preSetScript(){

    //トップに戻るボタン + スクロール + ウィンドウサイズ系の対策処理
    function scrollAnimationSet(target) {
      const scButtonWrap = $('#scrollTopWrap');
      const indexProducts = document.getElementById("indexProducts");
      const position = document.documentElement;
      let wHeight = window.innerHeight;
      let preSetWidth = window.innerWidth;
      let scrollCount = 0;

      function setHeightProperty() {
        wHeight = window.innerHeight;
        position.style.setProperty('--wHeight', window.innerHeight);
        position.style.setProperty('--wHeightPx', window.innerHeight + 'px');
        position.style.setProperty('--scroll', window.scrollY);

        if (document.getElementById('index')) {
          if(window.scrollY > 120){
            $('header').removeClass('index');
          }else{
            $('header').addClass('index');
          }
        }

        requestAnimationFrame(setHeightProperty);
      }

      function setProperties() {
        setHeightProperty();
      }

      function init() {
        /*const scrollButton = document.querySelector('#returnTop');
        scrollButton.addEventListener( 'click' , scrollTop );*/
        function scrollTop(){
          window.scroll({top: 0, behavior: 'smooth'});
        };
        var timer = false;
        setProperties();
        position.style.setProperty('--wHeightFixedPx', window.innerHeight + 'px');
        setProperties();
      }

      init();

    }

    scrollAnimationSet($('article'));




    // 目次ボタン
    function indexAnker(target){
      var ankerButton = [];
      var scrollTarget = [];

      function windowMove(e) {
        var headerHeight = $('header').outerHeight();
        var scrollHeight = $(scrollTarget[e]).offset().top;
        var adScroll = scrollHeight - headerHeight;
        $("html, body").animate({
          scrollTop: adScroll
        }, 500);
      }


      function init(){
        target.find('button').each(function(index) {
          ankerButton[index] = $(this);
          scrollTarget[index] = $(this).attr('jump');
          ankerButton[index].on({
            'click': function() {
              windowMove(index);
            }
          });
        });
      }

      init();

    }

    if (document.getElementById('pageIndexButton')) {
      indexAnker($('#pageIndexButton'));
    }


    //商品詳細ページ サムネイルの切り替え
    function thumbSwitcher(target){
      let thumbButton = [];
      let thumbSrc = [];
      let thumbSrcSet = [];
      let thumbBox = target.find('.thumb_img');
      let thumbImage = thumbBox.find('img');
      let slideNum = target.find('.thumbnails').find('img').length;
      const time = 200;
      let currentSlide = 0;
      console.log('slideNum:' + slideNum);

      function switchImage(num){
        console.log('num:' + num);
        thumbBox.stop().animate({ opacity: 0 }, time, function() {
            thumbImage.attr('src', thumbSrc[num]);
            thumbImage.attr('srcset', thumbSrcSet[num]);
            $('.active_thumb').removeClass('active_thumb');
            thumbButton[num].addClass('active_thumb');
            thumbBox.stop().animate({ opacity: 1 }, time);
        });
      }

      function thumbHeightControll(){
        var thumbHeight = thumbImage.outerHeight();
        $('#thumnails').css({'max-height': thumbHeight + 'px'});
        requestAnimationFrame(thumbHeightControll);
      }

      function slideNext(){
        if (currentSlide < slideNum - 1) {
          currentSlide = currentSlide + 1;
        } else {
          currentSlide = 0;
        }
        thumbButton[currentSlide].click();
        /*switchImage(currentSlide);*/
      };

      function slidePrev(){
        if (currentSlide == 0) {
          currentSlide = slideNum - 1;
        } else {
          currentSlide = currentSlide - 1;
        }
        thumbButton[currentSlide].click();
        /*switchImage(currentSlide);*/
      };

      function tabTouch(){
        if(startTouchX - endTouchX > 50){
          slideNext();
        }else if(startTouchX - endTouchX < - 50){
          slidePrev();
        }
      };

      function windowDrag() {
        if (startDragX - endDragX > 100) {
          slideNext();
        } else if (startDragX - endDragX < -100) {
          slidePrev();
        }
      };

      function init(){
        thumbHeightControll();
        $.each(target.find('.thumbnails').find('button'), function(index) {
          thumbButton[index] = $(this);
          thumbSrc[index] = $(this).find('img').attr("src");
          thumbSrcSet[index] = $(this).find('img').attr("srcset");
          thumbButton[index].on({
            'click': function() {
              switchImage(index);
            }
          });
        });

        thumbBox.find('img').on({
          'dragstart': function(e) {
            event.preventDefault();
            startDragX = event.pageX;
          },
          'dragend': function(e) {
            endDragX = event.pageX;
            windowDrag();
          }
        });

        thumbBox.find('img').on({
          'touchstart' : function(e){
            event.preventDefault();
            startTouchX = event.changedTouches[0].pageX;
          },
          'touchmove' : function(e){
          },
          'touchend' : function(e){
            endTouchX = event.changedTouches[0].pageX;
            tabTouch();
          }
        });

        $(window).on({
          'resize': function(){
            thumbHeightControll();
          }
        });
      }

      init();

    }

    if (document.getElementById('product')) {
      thumbSwitcher($('#prodImages'));
    }


    //商品詳細ページ 購入数の増減 & バリエーションの切り替え
    function cartWrapControll(){
      var minusButton = $('#minusButton');
      var plusButton = $('#plusButton');
      var quantityInput = $('#quantityInput');
      var quantityNum = 1;
      var optionSelector = $('#optionSelector');
      var optionValue;
      var optionLabel = [];
      var optionLabelValue = [];
      var labelState = [];

      var cartInButton = $('#cartInButton');
      var cartURL;

      function setCartInURL(){
        cartURL = '/cart/add?id=' + optionValue + '&quantity=' + quantityNum;
        cartInButton.attr('href', cartURL);
      }

      function controllQuantity(vector){
        quantityNum = quantityInput.val();
        if(vector == 1){
          quantityInput.attr('value', Number(quantityNum) + 1);
          quantityNum = quantityInput.val();
        }else{
          if(quantityNum != 1){
            quantityInput.attr('value', Number(quantityNum) - 1);
            quantityNum = quantityInput.val();
          }
        }
        setCartInURL();
      }

      function changeProductOption(i,e){
        optionValue = e;
        $('.active_label').removeClass('active_label');
        if(labelState != i){
          optionLabel[i].addClass('active_label');
          labelState = i;
        }
        setCartInURL();
      }

      function init(){

        minusButton.on({
          'click': function() {
            event.preventDefault();
            controllQuantity(-1);
          }
        });

        plusButton.on({
          'click': function() {
            event.preventDefault();
            controllQuantity(1);
          }
        });

        // 通常購入のサイズ切り替え
        $.each(optionSelector.find('label'), function(index) {
          optionLabel[index] = $(this);
          optionLabelValue[index] = $(this).find('input').val();
          labelState[index] = 0;
          optionLabel[index].on({
            'click': function() {
              event.preventDefault();
              changeProductOption(index, optionLabelValue[index]);
            }
          });
        });

        optionValue = optionLabelValue[0];



      };

      init();

    }

    if (document.getElementById('product')) {
      cartWrapControll();
    }

    if (document.getElementById('index')) {
      cartWrapControll();
    }

    // 商品詳細ページ 蛇腹式レイアウト
    function toggleControl(target){
      let toggleItem = [];
      let toggleButton = [];
      let toggleContents = [];
      let toggleInner = [];
      let toggleType = [];
      let toggleState = [];
      let toggleState2 = [];
      let toggleInToggle = [];
      let windowWidth;
      let spWidth = 721;


      function toggleMove(e) {
        var buttonHeight = toggleButton[e].outerHeight();
        var tagetHeight = toggleInner[e].outerHeight();
        if (toggleState[e] == -1 || toggleState[e] == 0) {
          toggleButton[e].addClass('open');
          toggleContents[e].css({
            'height': tagetHeight + 'px'
          });
          toggleState[e] = 1;
        } else {
          toggleButton[e].removeClass('open');
          var toggleHeight = toggleButton[e].outerHeight();
            toggleContents[e].css({
              'height': 0 + 'px'
            });
          toggleState[e] = 0;
        }
      }

      function init(){
        windowWidth = $(window).width();
        $.each(target.find('.toggle_item'), function(index) {
          toggleItem[index] = $(this);
          toggleButton[index] = $(this).find('.toggle_button');
          toggleContents[index] = $(this).find('.toggle_contents');
          toggleInner[index] = $(this).find('.toggle_inner');
          toggleType[index] = toggleItem[index].attr('type');
          var tagetHeight = toggleInner[index].outerHeight();
          if(toggleType[index] == 'open'){
            toggleContents[index].css({'height': tagetHeight + 'px'});
            toggleState[index] = 1;
            toggleState2[index] = -1;
          }else if(toggleType[index] == 'close'){
            toggleContents[index].css({'height': 0 + 'px'});
            toggleState[index] = 0;
            toggleState2[index] = -1;
          }else{
            toggleContents[index].css({'height': tagetHeight + 'px'});
            toggleState[index] = 1;
            toggleState2[index] = -1;
          }
          toggleButton[index].on({
            'click': function() {
              toggleMove(index);
            }
          });

        });
      }

      init();

    }

    if (document.getElementById('product')) {
      toggleControl($('#toggles'))
    }

    if (document.getElementById('index')) {
      toggleControl($('#toggles'))
    }


    // カートページ 商品数の増減
    function controllProductQuantity(target){
      var minusButton = [];
      var plusButton = [];
      var quantityInput = [];
      var reloadButton = [];
      var quantityNum;

      function controllQuantity(num, vector){
        quantityNum = quantityInput[num].val();
        if(vector == 1){
          quantityInput[num].attr('value', Number(quantityNum) + 1);
          reloadButton[num].click();
        }else{
          if(quantityNum != 1){
            quantityInput[num].attr('value', Number(quantityNum) - 1);
            reloadButton[num].click();
          }
        }
      }

      function init(){
        $.each(target.find('.cart_item'), function(index) {
          minusButton[index] = $(this).find('.minus');
          plusButton[index] = $(this).find('.plus');
          quantityInput[index] = $(this).find('input[type="number"]');
          reloadButton[index] = $(this).find('.reload_button');
          minusButton[index].on({
            'click': function() {
              event.preventDefault();
              controllQuantity(index, -1);
            }
          });
          plusButton[index].on({
            'click': function() {
              event.preventDefault();
              controllQuantity(index, 1);
            }
          });
        });

      }

      init();

    }

    if (document.getElementById('cartItem')) {
      controllProductQuantity($('#cartItem'));
    }

    // カートページ 配送方法の指定
    function controllDeliveryMethods(){
      var methodLabel = [];
      var deliveryOptionWrap = $('#deliveryOptions');
      var deliveryDate = $('#deliveryDateBox');
      var deliveryTime = $('#deliveryTime');
      var deliveryOptions = $('input[name=delivery_method]');
      var sideWrapDay = $('#sideWrapDay');
      var sideWrapDate = $('#sideWrapDate');
      var methodInput = $('#methodInput');

      function setNekopos(){
        sideWrapDay.addClass('disabled');
        sideWrapDate.addClass('disabled');
        $('.active_label').removeClass('active_label');
        methodLabel[0].addClass('active_label');
        deliveryDate.val('指定なし');
        deliveryTime.val('指定なし');
        $('#dateInput').val('指定なし');
        methodInput.val('クロネコゆうパケット');
        $('.souryou-nashi').css({'display': 'block'});
        $('.souryou-ari').css({'display': 'none'});
      }

      function setTakkyu(){
        sideWrapDay.removeClass('disabled');
        sideWrapDate.removeClass('disabled');
        $('.active_label').removeClass('active_label');
        methodLabel[1].addClass('active_label');
        methodInput.val('宅急便');
        $('.souryou-nashi').css({'display': 'none'});
        $('.souryou-ari').css({'display': 'block'});
      }

      function init(){

        deliveryOptions.on({
          'change': function() {
            var inputValue = $('input[name=delivery_method]:checked').val();
            console.log('inputValue:' + inputValue);
            if(inputValue == 1){
              location.href = 'https://wdj1981.com/cart/add?id=47309697548533&quantity=1';
            }else{
              var url = $('#takkyuCancel').attr('href');
              location.href = url;
            }
          }
        });

        deliveryDate.on({
          'change': function() {
            var inputValue = deliveryDate.val();
            console.log('inputValue:' + inputValue);
            if(inputValue == 1){
              $('#dateInput').val(inputValue);
            }else{
              $('#dateInput').val();

            }
          }
        });

      }

      init();

    }

    if (document.getElementById('cart')) {
      controllDeliveryMethods();
    }

    //キャンペーンポップアップ
    function campaignPopDisplay(){
      var campaignPop = $('#campaignPop');
      var campaignPopBg = $('#campaignPopBg');
      var campaignPopClose = $('#campaignPopClose');

      function init(){

        setTimeout(function() {
          campaignPop.addClass('open');
        }, 1500);

        campaignPopBg.on({
          'click': function() {
            campaignPop.removeClass('open');
          }
        });

        campaignPopClose.on({
          'click': function() {
            campaignPop.removeClass('open');
          }
        });



      }

      init();

    }

    if (document.getElementById('campaignPop')) {
      campaignPopDisplay();
    }

    // 送料テーブルポップアップ
    // 送料詳細のポップアップ
    function shippingPopDisplay(){
      var shippingFeePop = $('#shippingFeePop');
      var shippingPopBg = $('#shippingPopBg');
      var shippingPopClose = $('#shippingPopClose');

      function init(){

        $.each($('body').find('.func-shipping-fee'), function(index) {
          console.log('index:' + index);
          $(this).on({
            'click': function() {
              shippingFeePop.addClass('open');
            }
          });
        });

        shippingPopBg.on({
          'click': function() {
            shippingFeePop.removeClass('open');
          }
        });

        shippingPopClose.on({
          'click': function() {
            shippingFeePop.removeClass('open');
          }
        });



      }

      init();

    }

    if (document.getElementById('shippingFeePop')) {
      shippingPopDisplay();
    }

    //再入荷通知ポップアップ
    function restockPopDisplay(){
      var restockPop = $('#restockPop');
      var restockPopBg = $('#restockPopBg');
      var restockPopClose = $('#restockPopClose');
      var restockButton = $('#restockButton');

      function init(){

        restockButton.on({
          'click': function() {
            restockPop.addClass('open');
          }
        });

        restockPopBg.on({
          'click': function() {
            restockPop.removeClass('open');
          }
        });

        restockPopClose.on({
          'click': function() {
            restockPop.removeClass('open');
          }
        });



      }

      init();

    }

    if (document.getElementById('waitingPop')) {
      /*restockPopDisplay();*/
    }

    //商品別ウェイティングリストの登録フォーム
    function setProductWaitingList(wrapper){

      var waitingPopBg = $('#restockPopBg');
      var waitingCloseButton = $('#restockPopClose');
      var waitingButton = $('#restockButton');



      function setProdWaitingForm(target){
        var ERROR_MESSAGE_CLASSNAME = 'errorMsg'; //エラー時のメッセージ要素のclass名
        var ERROR_INPUT_CLASSNAME = 'errorInput'; //エラー時のinput要素のclass名
        var errorCount = 0;
        var submitWrap = $('#registerSubmit');
        var submitButton = $('#registerSubmit input');
        var items = []; //チェック対象となるテキスト入力要素を格納した配列

        var mailInputArart = '※メールアドレスをご入力ください。';
        var mailFormatArrat = '※アドレスの形式をご確認ください';

        //項目チェックする
        var checkAll = function(){
          errorCount = 0;

          //input,textareaのチェック
          for( var i=0; i<items.length; i++ ){
            if( items[i].prop('isSuccess') == false ){
              errorCount++;
              console.log('error:' + i);
            };
          };

          if( errorCount == 0 ){
          }else{
          };
        };

        //エラーメッセージの追加
        var addErrorMessage = function(selector, msg){
          removeErrorMessage(selector);
          selector.parent('div').append('<span class="attention '+ERROR_MESSAGE_CLASSNAME+'">'+msg+'</span>');
          selector.addClass(ERROR_INPUT_CLASSNAME);
        };

        //エラーメッセージの削除
        var removeErrorMessage = function(selector){
          var msgSelector = selector.parent().parent('div').find('.'+ERROR_MESSAGE_CLASSNAME);
          if( msgSelector.length != 0 ){
            msgSelector.remove();
            selector.removeClass(ERROR_INPUT_CLASSNAME);
          };
        };

        //input,textareaの未入力チェック
        var checkEmptyText = function(selector, msg){
          if( selector.val() == '' ||  selector.val() == null){
            addErrorMessage(selector, msg);
            selector.prop('isSuccess', false);
          }else{
            removeErrorMessage(selector);
            selector.prop('isSuccess', true);
          };
        };

        var emptyThrough = function(selector){
          if( selector.val() == '' ||  selector.val() == null){
            removeErrorMessage(selector);
            selector.prop('isSuccess', true);
          }
        };

        //radioの未入力チェック
        var checkRadioBox = function(selector, msg){
          if( selector.prop("checked")){
            removeErrorMessage(selector);
            selector.prop('isSuccess', true);
          }else{
            addErrorMessage(selector, msg);
            selector.prop('isSuccess', false);
          };
        };

        //文字列のフォーマットチェック
        function checkFormatText(selector, _mode, msg){
          var value = selector.val();
          switch(_mode){
            //全角のみ
            case 0:
              if(value.match(/^[^ -~｡-ﾟ]*$/)){
                selector.prop('isSuccess', true);
                removeErrorMessage(selector);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //ふりがなのみ
            case 1:
              if(value.match(/^[\u3040-\u309F]+$/)){
                selector.prop('isSuccess', true);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //半角数字のみ
            case 2:
              if(value.match(/^[0-9\-]+$/)){
                selector.prop('isSuccess', true);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //メールアドレスかどうか
            case 3:
              if(value.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,6}$/)){
                selector.prop('isSuccess', true);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //カタカナのみ
            case 4:
              if(value.match(/^[\u30A0-\u30FF]+$/) || value.match(/^[\uFF61-\uFF9F]+$/)){
                selector.prop('isSuccess', true);
              }else{
                selector.prop('isSuccess', false);
              };
              break;
            //全てエラーにする
            case 5:
              selector.prop('isSuccess', false);
              break;
          };
          if( selector.prop('isSuccess') == false ){
            addErrorMessage(selector, msg);
          }else{
            removeErrorMessage(selector);
          };
        };

        //初期設定
        var init = function(){
          //submitイベントの設定
          target.on({
            'submit': function(){
              checkAll();
            }
          });
          //input要素を配列に格納
          items = [
            target.find('input[name="yourMail"]'), //0 メールアドレス
          ];
          //input要素のプロパティを設定
          $.each(items, function(index){
            items[index].prop('isSuccess', false);
          });

          //enterキーでsubmitしてしまうのを防止する
          target.find('input[type=text]').on({
            'keypress': function(e){
              if( (e.keyCode == 13) ) return false;
            }
          });

          //1 メールアドレス
          items[0].on({
            'blur': function(){
              checkEmptyText( items[0], mailInputArart );
              if( items[0].prop('isSuccess') ) checkFormatText( items[0], 3, mailFormatArrat );
              checkAll();
            }
          });

          submitButton.on({
            'click': function(){
              checkEmptyText( items[0], mailInputArart);
              if( items[0].prop('isSuccess') ) checkFormatText( items[0], 3, mailFormatArrat );
              checkAll();
              if( errorCount == 0 ){
                processOrderContent();
              }else{
                alert('入力内容に不備があります。入力内容を確認いただき、再度送信ボタンを押してください。');
                var scrollHeight = $('#contact').offset().top;
                $("html, body").animate({
                  scrollTop: scrollHeight
                }, 300);
              };
            }
          })
        };

        function processOrderContent(){
          $('#registerSubmit').addClass('completed');
          $('#ajaxLoader').addClass('loading_state');
          // メールアドレス
          var prodTitle = target.find("input[name=prodTitle]").val();
          var prodID = target.find("input[name=prodID]").val();
          var userMail = target.find("input[name=yourMail]").val();
          event.preventDefault();
          setTimeout(function() {
            $('#ajaxLoader').removeClass('loading_state');
            $('#registerSubmit').remove();
              $('#statusMessage').addClass('complete').html('<span class="text">メールアドレスの登録が完了しました。</span>');
          }, 1000);
        }

        init();

      };

      function init(){

        waitingButton.on({
          'click': function() {
            wrapper.addClass('open');
          }
        });

        waitingCloseButton.on({
          'click': function() {
            wrapper.removeClass('open');
          }
        });

        waitingPopBg.on({
          'click': function() {
            wrapper.removeClass('open');
          }
        });

        setProdWaitingForm($('#prodWaitingForm'));


      }

      init();

    }

    if (document.getElementById('waitingPop')) {
      setProductWaitingList($('#waitingPop'));
    }

    // 記事詳細ページ リンクをコピーボタン
    function linkCopyButtons(){
      console.log('linkCopyButtons');
      var copyButton = $('#urlCopyButton');

      function copyUrl() {
        console.log('copy!');
        const element = document.createElement('input');
        element.value = location.href;
        document.body.appendChild(element);
        element.select();
        document.execCommand('copy');
        document.body.removeChild(element);
        copyButton.addClass('copied');
        copyButton.find('.txt').html('コピーしました')
        setTimeout(function() {
          copyButton.removeClass('copied');
          copyButton.find('.txt').html('URLをコピー')
        }, 2000);
      }

      function init(){

        copyButton.on({
          'click': function() {
            copyUrl();
          }
        });
      }

      init();

    }

    if (document.getElementById('newsDetail')) {
      linkCopyButtons();
    }

    /* ログインページの切り替えレイアウト */
    function switchLoginFunction(){
      var loginLayout = $('#login');
      var resetLayout = $('#reset');
      var resetPassword = $('#resetPassword');
      var loginBack = $('#loginBack');
      var urlHash = location.hash;
      var switchState = 0;

      function switchLogin(){
        if(switchState != 0){
          $('#contentSwitcher').animate({opacity:0}, 400, function(){
              loginLayout.css({'display': 'block'});
              resetLayout.css({'display': 'none'});
              $("#contentSwitcher").css({'display': 'block'});
              setTimeout(function() {
                $("#contentSwitcher").animate({opacity: 1}, 400, function(){
                  $('#footerBg').animate({opacity: 1}, 1);
                });
              }, 50);
          });
        }
      }

      function switchReset(){
        $('#contentSwitcher').animate({opacity:0}, 400, function(){
            loginLayout.css({'display': 'none'});
            resetLayout.css({'display': 'block'});
            $("#contentSwitcher").css({'display': 'block'});
            setTimeout(function() {
              $("#contentSwitcher").animate({opacity: 1}, 400, function(){
                $('#footerBg').animate({opacity: 1}, 1);
              });
            }, 50);
            switchState = 1;
        });
      }

      function init(){
        if(urlHash.indexOf('recover') > -1){
          switchReset();
        }else{
          switchLogin();
        }
        resetPassword.on({
          'click': function() {
            event.preventDefault();
            switchReset();
          }
        });

        loginBack.on({
          'click': function() {
            event.preventDefault();
            switchLogin();
          }
        });

      }

      init();

    }

    if (document.getElementById('contentSwitcher')) {
      switchLoginFunction();
    }

    /* 住所一覧ページの切り替えレイアウト */
    function switchAddressFunction(){
      var addressContentWrap = $('#addressContentWrap');
      var wrapperList = $('#wrapperList');
      var wrapperAdd = $('#wrapperAdd');
      var addressList = $('#addressList');
      var addressEdit = $('#addressEdit');
      var adminBar = $('#adminBar');
      var editbutton = [];
      var editId = [];


      function switchList(){
        adminBar.removeClass('mode-edit').addClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
          $('.content_wrapper').css({'display': 'none'});
          wrapperList.css({'display': 'block'});
          addressContentWrap.css({'display': 'block'});
          setTimeout(function() {
            addressContentWrap.animate({opacity: 1}, 400);
          }, 50);
        });
      }

      function switchAdd(){
        adminBar.addClass('mode-edit').removeClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
            $('.content_wrapper').css({'display': 'none'});
            wrapperAdd.css({'display': 'block'});
            addressContentWrap.css({'display': 'block'});
            setTimeout(function() {
              addressContentWrap.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function switchEdit(e){
        adminBar.addClass('mode-edit').removeClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
            $('.content_wrapper').css({'display': 'none'});
            $('#' + editId[e]).css({'display': 'block'});
            addressContentWrap.css({'display': 'block'});
            setTimeout(function() {
              addressContentWrap.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function init(){
        addressList.on({
          'click': function() {
            event.preventDefault();
            switchList();
          }
        });

        addressEdit.on({
          'click': function() {
            event.preventDefault();
            switchAdd();
          }
        });

        $.each($('article').find('.btn_edit'), function(index) {
          editbutton[index] = $(this);
          editId[index] = $(this).attr('formId');
          editbutton[index].on({
            'click': function() {
              console.log(editId[index]);
              switchEdit(index);
            }
          });
        });

      }

      init();

    }

    if (document.getElementById('addressContentWrap')) {
      switchAddressFunction();
    }


    /* お問い合わせフォームのGAS連動とバリデーション */
    function setMyForm(target){
      console.log('setMyForm');
      var ERROR_MESSAGE_CLASSNAME = 'errorMsg'; //エラー時のメッセージ要素のclass名
      var ERROR_INPUT_CLASSNAME = 'errorInput'; //エラー時のinput要素のclass名
      var errorCount = 0;
      var submitWrap = $('#submit');
      var submitButton = $('#submitButton input');
      var items = []; //チェック対象となるテキスト入力要素を格納した配列

      //項目チェックする
      var checkAll = function(){
        errorCount = 0;

        //input,textareaのチェック
        for( var i=0; i<items.length; i++ ){
          if( items[i].prop('isSuccess') == false ){
            errorCount++;
            console.log('error:' + i);
          };
        };

        if( errorCount == 0 ){
        }else{
        };
      };

      function hankaku2Zenkaku(target) {
        var str = target.val();
        str = str.replace( /[Ａ-Ｚａ-ｚ０-９－！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
        }).replace(/[ー]/g, '').replace(/[−]/g, '');

        target.val(str.trim().replace(/\s+/g, ''));
      }

      //エラーメッセージの追加
      var addErrorMessage = function(selector, msg){
        removeErrorMessage(selector);
        selector.parent('div').append('<span class="attention '+ERROR_MESSAGE_CLASSNAME+'">'+msg+'</span>');
        selector.addClass(ERROR_INPUT_CLASSNAME);
      };

      //エラーメッセージの削除
      var removeErrorMessage = function(selector){
        var msgSelector = selector.parent().parent('div').find('.'+ERROR_MESSAGE_CLASSNAME);
        if( msgSelector.length != 0 ){
          msgSelector.remove();
          selector.removeClass(ERROR_INPUT_CLASSNAME);
        };
      };

      //input,textareaの未入力チェック
      var checkEmptyText = function(selector, msg){
        if( selector.val() == '' ||  selector.val() == null){
          addErrorMessage(selector, msg);
          selector.prop('isSuccess', false);
        }else{
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        };
      };

      var emptyThrough = function(selector){
        if( selector.val() == '' ||  selector.val() == null){
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        }
      };

      //radioの未入力チェック
      var checkRadioBox = function(selector, msg){
        if( selector.prop("checked")){
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        }else{
          addErrorMessage(selector, msg);
          selector.prop('isSuccess', false);
        };
      };

      //文字列のフォーマットチェック
      function checkFormatText(selector, _mode, msg){
        var value = selector.val();
        switch(_mode){
          //全角のみ
          case 0:
            if(value.match(/^[^ -~｡-ﾟ]*$/)){
              selector.prop('isSuccess', true);
              removeErrorMessage(selector);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //ふりがなのみ
          case 1:
            if(value.match(/^[\u3040-\u309F]+$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //半角数字のみ
          case 2:
            if(value.match(/^[0-9\-]+$/) || value.length < 1 ){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //メールアドレスかどうか
          case 3:
            if(value.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,6}$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //カタカナのみ
          case 4:
            if(value.match(/^[\u30A0-\u30FF]+$/) || value.match(/^[\uFF61-\uFF9F]+$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //全てエラーにする
          case 5:
            selector.prop('isSuccess', false);
            break;
        };
        if( selector.prop('isSuccess') == false ){
          addErrorMessage(selector, msg);
        }else{
          removeErrorMessage(selector);
        };
      };

      //初期設定
      var init = function(){
        //submitイベントの設定
        target.on({
          'submit': function(){
            checkAll();
          }
        });
        //input要素を配列に格納
        items = [
          target.find('#ContactFormName'), //0 お名前
          target.find('#ContactFormCorp'), //1 会社名
          target.find('#ContactFormEmail'), //2 メールアドレス
          target.find('#ContactFormEmai2'), //3 メールアドレス確認用
          target.find('#ContactFormPhone'), //4 電話番号
          target.find('#ContactFormMessage'), //5 ご相談内容
          target.find('input[name=agreement]'), //6 プラポリへの合意
        ];
        //input要素のプロパティを設定
        $.each(items, function(index){
          items[index].prop('isSuccess', false);
        });

        //enterキーでsubmitしてしまうのを防止する
        target.find('input[type=text]').on({
          'keypress': function(e){
            if( (e.keyCode == 13) ) return false;
          }
        });
        //0 お名前
        items[0].on({
          'blur': function(){
            checkEmptyText( items[0], '※お名前を入力してください。' );
            checkAll();
          }
        });

        //1 会社名
        items[1].prop('isSuccess', true);

        //2 メールアドレス
        items[2].on({
          'blur': function(){
            checkEmptyText( items[2], '※メールアドレスをご入力ください。' );
            if( items[2].prop('isSuccess') ) checkFormatText( items[2], 3, 'アドレスの形式をご確認ください' );
            checkAll();
          }
        });

        //3 メールアドレス(確認用)
        items[3].on({
          'blur': function(){
            checkEmptyText( items[3], '※確認用メールアドレスは必須です。');
            if( items[3].prop('isSuccess') ){
              checkFormatText( items[3], 3, '※確認用メールアドレスの形式をご確認ください' );
              if(items[2].val() != items[3].val()){
                checkFormatText( items[3], 5, '※メールアドレスが一致しません。' );
              }
            }

            checkAll();

          }
        });

        //4 電話番号
        items[4].prop('isSuccess', true);
        items[4].on({
          'blur': function(){
            hankaku2Zenkaku($(this));
            if( items[4].prop('isSuccess') ) checkFormatText( items[4], 2, '※電話番号は数字で入力してください。');
            checkAll();
          }
        });

        //5 ご相談内容
        items[5].on({
          'blur': function(){
            checkEmptyText( items[5], '※ご相談内容を入力してください。' );
            checkAll();
          }
        });

        console.log('items[6]:' + items[6].attr('id'));

        //6 プラポリへの合意
        items[6].on({
          'change': function(){
            console.log('check!');
            var agreeState = $('input[name=agreement]:checked').val();
            if(agreeState == 1){
              items[6].prop('isSuccess', true);
              $('#submitButton').removeClass('disabled');
            }else{
              items[6].prop('isSuccess', false);
              $('#submitButton').addClass('disabled');
            }
          }
        });

        submitButton.on({
          'click': function(){
            checkEmptyText( items[0], '※お名前を入力してください。' );
            checkEmptyText( items[2], '※メールアドレスをご入力ください。' );
            if( items[2].prop('isSuccess') ) checkFormatText( items[2], 3, 'アドレスの形式をご確認ください' );
            checkEmptyText( items[3], '※確認用メールアドレスは必須です。');
            if( items[3].prop('isSuccess') ){
              checkFormatText( items[3], 3, '※確認用メールアドレスの形式をご確認ください' );
              if(items[2].val() != items[3].val()){
                checkFormatText( items[3], 5, '※メールアドレスが一致しません。' );
              }
            }
            if( items[4].prop('isSuccess') ) checkFormatText( items[4], 2, '※電話番号は数字で入力してください。');
            checkEmptyText( items[5], '※ご相談内容を入力してください。' );
            items[1].prop('isSuccess', true);
            checkAll();
            if( errorCount == 0 ){
              processOrderContent();
            }else{
              alert('入力内容に不備があります。入力内容を確認いただき、再度送信ボタンを押してください。');
              var scrollHeight = $('#contact').offset().top;
              $("html, body").animate({
                scrollTop: scrollHeight
              }, 300);
            };
          }
        })
      };

      function processOrderContent(){
        $('#submitButton').addClass('disabled');
        $('#ajaxLoader').addClass('loading_state');
        setTimeout(function() {
          $('#ajaxLoader').removeClass('loading_state');
          $('#statusMessage').addClass('complete').html('<span class="text">メッセージは送信されました。<br>内容を確認の上、担当者よりご返信いたします。</span>');
          setTimeout(function() {
            $('#contacrFormWrap').submit();
          }, 1000);
        }, 1000);
      }

      init();

    };

    if (document.getElementById('contactWrap')) {
      setMyForm($('#contactWrap'));
    }

  }

  preSetScript();


});
